module.exports = __webpack_public_path__ + "img/kadiri.5459c9be.jpg";